import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';

const selectors = {
	el: '.js-accord',
	toggle: '.js-accord-toggle',
	content: '.js-accord-content'
};

const classes = {
	visible: 'visible'
};

const onClick = e => {
	const visibleClass = classes.visible;
	const target = e.currentTarget;
	const content = target.nextElementSibling;
	content.classList.toggle(visibleClass);
};

const setHandlers = () => {
	bindEvent(selectors.toggle, 'click', onClick);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/accord/index.js